/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Class_Listaspectcontainsandaspect14Inputs */

const de__class_listaspectcontainsandaspect14 = /** @type {(inputs: _Class_Listaspectcontainsandaspect14Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`beinhaltet alle von`)
};

/**

* @param {_Class_Listaspectcontainsandaspect14Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _class_listaspectcontainsandaspect14 = /** @type {((inputs?: _Class_Listaspectcontainsandaspect14Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Class_Listaspectcontainsandaspect14Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__class_listaspectcontainsandaspect14(inputs)
});
export { _class_listaspectcontainsandaspect14 as "_class_ListAspectCONTAINSANDAspect" }